module.exports = __webpack_public_path__ + "img/1.ea00ff43.jpg";